import { StateCreator } from 'zustand'

import { EphemeralStore } from '../useEphemeralStore'

export interface IPageState {
    scrollTop?: number
    openDisclosures?: string[]
    closedDisclosures?: string[]
}

interface IPageStates {
    pageStates: Record<string, IPageState>
}
interface IPageStateActions {
    setPageState: (key: string, state: IPageState) => void
    setDisclosureState: (
        key: string,
        disclosureId: string,
        open: boolean
    ) => void
    setScrollTop: (key: string, scrollTop: number) => void
}
export interface PageStateSlice extends IPageStates, IPageStateActions {}

export const createPageStateSlice: StateCreator<
    EphemeralStore,
    [],
    [],
    PageStateSlice
> = (set, get) => ({
    pageStates: {},
    setPageState: (key: string, state: IPageState) => {
        set((s) => ({
            pageStates: {
                ...s.pageStates,
                [key]: state,
            },
        }))
    },
    setDisclosureState: (key: string, disclosureId: string, open: boolean) => {
        set((s) => {
            const pageState = s.pageStates[key] || {}
            const openDisclosures = pageState.openDisclosures || []
            const closedDisclosures = pageState.closedDisclosures || []
            if (open) {
                // If the disclosure is being opened, remove it from closedDisclosures
                const index = closedDisclosures.indexOf(disclosureId)
                if (index > -1) {
                    closedDisclosures.splice(index, 1)
                }
                openDisclosures.push(disclosureId)
            } else {
                // If the disclosure is being closed, remove it from openDisclosures
                const index = openDisclosures.indexOf(disclosureId)
                if (index > -1) {
                    openDisclosures.splice(index, 1)
                }
                closedDisclosures.push(disclosureId)
            }
            return {
                pageStates: {
                    ...s.pageStates,
                    [key]: { ...pageState, openDisclosures, closedDisclosures },
                },
            }
        })
    },
    setScrollTop: (key: string, scrollTop: number) => {
        set((s) => ({
            pageStates: {
                ...s.pageStates,
                [key]: { ...s.pageStates[key], scrollTop },
            },
        }))
    },
})
